import React, { useState } from 'react';
import Cookies from 'js-cookie';
import {
	Dialog,
	// DialogTitle,
	DialogContent,
	DialogActions,
	Typography,
	Switch,
	FormControlLabel,
	Button,
	Stack,
	Box
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

type Props = { open: boolean; onClose: () => void };

const COOKIE_KEY = 'simsola.ai_site_consent_v1';

const PreferencesDialog: React.FC<Props> = ({ open, onClose }) => {
	const navigate = useNavigate();
	// read existing consent or default (marketing = false)
	const cookie = Cookies.get(COOKIE_KEY);
	const current = cookie
		? JSON.parse(cookie)
		: { necessary: true, preferences: false, statistics: false, marketing: false };

	const [marketing, setMarketing] = useState<boolean>(current.marketing);

	const save = () => {
		Cookies.set(
			COOKIE_KEY,
			JSON.stringify({
				necessary: true,
				preferences: marketing,
				statistics: marketing,
				marketing
			}),
			{ expires: 180, sameSite: 'lax', secure: true, path: '/' }
		);
		onClose();
	};
	const saveAll = () => {
		Cookies.set(
			COOKIE_KEY,
			JSON.stringify({
				necessary: true,
				preferences: true,
				statistics: true,
				marketing: true
			}),
			{ expires: 180, sameSite: 'lax', secure: true, path: '/' }
		);
		onClose();
	};
	return (
		<Dialog
			open={open}
			maxWidth="sm"
			fullWidth
			scroll="paper"
			PaperProps={{
				sx: {
					backgroundColor: 'rgba(41, 41, 41, 1)',
					color: 'rgba(255, 255, 255, 1)',
					borderRadius: '15px',
					maxWidth: '500px'
				}
			}}>
			{/* <DialogTitle fontFamily="DM Sans" fontWeight={700} fontSize={24}>
				Preferences
			</DialogTitle> */}

			<DialogContent dividers>
				<Typography sx={{ fontFamily: 'DM Sans', fontWeight: '700', fontSize: '24px', lineHeight: '150%' }}>
					Preferences
				</Typography>
				<Typography variant="body2" sx={{ fontFamily: 'DM Sans', fontSize: 16, lineHeight: '150%' }} mb={3}>
					We use different types of cookies to optimise your experience on our website. Click on the categories below to
					learn more about their purposes. You may choose which types of cookies to allow and can change your
					preferences at any time. Remember that disabling cookies may affect your experience on the website. You can
					learn more about how we use cookies by visiting our{' '}
					<u
						style={{ cursor: 'pointer' }}
						onClick={() => {
							navigate('/privacy-policy');
							onClose();
						}}>
						Privacy Policy.
					</u>
				</Typography>

				<Stack spacing={2}>
					{/* Essential – always on & disabled */}
					<FormControlLabel
						sx={{ alignItems: 'flex-start' }}
						control={<Switch checked disabled />}
						label={
							<Box>
								<Box sx={{ fontSize: '16px', fontFamily: 'DM Sans', color: 'rgba(255, 255, 255, 1)' }}>
									Essential cookies
								</Box>
								<Box>
									<Typography
										variant="body2"
										sx={{
											fontFamily: 'DM Sans',
											fontSize: '14px',
											lineHeight: '150%',
											color: 'rgba(255, 255, 255, 1)'
										}}>
										These cookies are necessary to the core functionality of our website and some of its features, such
										as access to secure areas.
									</Typography>
								</Box>
							</Box>
						}
					/>

					{/* Marketing & analytics – user controlled */}
					<FormControlLabel
						sx={{ alignItems: 'flex-start' }}
						control={
							<Switch
								checked={marketing}
								onChange={(_, v) => setMarketing(v)}
								inputProps={{ 'aria-label': 'Marketing and analytics cookies' }}
							/>
						}
						label={
							<Box>
								<Box sx={{ fontSize: '16px', fontFamily: 'DM Sans', color: 'rgba(255, 255, 255, 1)' }}>
									Marketing &amp; Analytic Cookies
								</Box>
								<Box>
									<Typography
										variant="body2"
										sx={{
											fontFamily: 'DM Sans',
											fontSize: '14px',
											lineHeight: '150%',
											color: 'rgba(255, 255, 255, 1)'
										}}>
										These cookies collect anonymous data to help us understand how visitors use our site and improve
										performance.
									</Typography>
								</Box>
							</Box>
						}
					/>
				</Stack>
			</DialogContent>

			{/* Two buttons on one line */}
			<DialogActions sx={{ p: 2 }}>
				<Stack direction="row" spacing={1} width="100%">
					<Button
						variant="contained"
						fullWidth
						onClick={saveAll}
						sx={{
							fontFamily: 'DM Sans',
							borderRadius: '10px',
							fontWeight: 500,
							fontSize: 16,
							width: '50%',
							textTransform: 'capitalize'
						}}>
						Accept All Cookies
					</Button>

					<Button
						variant="outlined"
						fullWidth
						onClick={save}
						sx={{
							fontFamily: 'DM Sans',
							borderRadius: '10px',
							width: '50%',
							fontWeight: 500,
							fontSize: 16,
							textTransform: 'capitalize',
							backgroundColor: 'rgba(108, 108, 108, 1)',
							color: 'white'
						}}>
						Accept Only Necessary
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default PreferencesDialog;
